import styled, { keyframes } from "styled-components";

import { rgba } from "@similarweb/styles";

const ping = keyframes`
    0% {
        transform: scale(1);
        opacity: 1;
    }
    75%, 100% {
        transform: scale(2.5);
        opacity: 0;
    }
`;

export const Ping = styled.div`
    position: relative;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #ff442d;

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        border-radius: 50%;
        background: ${rgba("#FF442D", 0.75)};
        animation: ${ping} 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
    }
`;
